import { useEffect, useCallback } from 'react';
import { useIntl } from 'umi';

const POST_LOCALE_MESSAGE_TYPE = 'DATABRAIN_LOCALE_CHANGE';

interface LocaleMessage {
  type: typeof POST_LOCALE_MESSAGE_TYPE;
  locale: string;
}

/**
 * 通过 postMessage 向嵌入的 iframe 页面下发当前系统语言
 * @param iframeRef iframe 元素的 ref，若不传则广播给所有同源 iframe
 */
export const usePostLocale = (iframeRef?: React.RefObject<HTMLIFrameElement>) => {
  const { locale } = useIntl();

  const postLocale = useCallback(
    (targetLocale: string) => {

      const message: LocaleMessage = {
        type: POST_LOCALE_MESSAGE_TYPE,
        locale: targetLocale,
      };

      if (iframeRef?.current?.contentWindow) {
        iframeRef.current.contentWindow.postMessage(message, '*');
        // console.info('[usePostLocale] locale message sent', {
        //   locale: targetLocale,
        //   target: 'iframeRef.current.contentWindow',
        //   type: POST_LOCALE_MESSAGE_TYPE,
        // });
      } else {
        const iframes = document.querySelectorAll('iframe');
        iframes.forEach((iframe) => {
          iframe.contentWindow?.postMessage(message, '*');
        });
        // console.info('[usePostLocale] locale message broadcast', {
        //   locale: targetLocale,
        //   target: 'all iframes',
        //   count: iframes.length,
        //   type: POST_LOCALE_MESSAGE_TYPE,
        // });
      }
    },
    [iframeRef],
  );

  useEffect(() => {
    postLocale(locale);
  }, [locale, postLocale]);

  // 返回手动触发方法，供外部按需调用
  return { postLocale, locale };
};
